import type { ProgramTimelineContentObject } from 'models';
import { Flex } from 'ui';
import { ProgramTopicPostBody } from './program-topic-post-body';
import { ProgramTopicPostHeader } from './program-topic-post-header';

export type PostType = 'activity' | 'event' | 'poll' | 'post' | 'withings_order_post';

type P = {
  last: boolean;
  onClick?: () => void;
  post: ProgramTimelineContentObject;
  type?: 'checked' | 'selected' | 'unchecked';
};

const ProgramTopicPost = ({ last, onClick, post, type }: P) => (
  <Flex className="program-topic-post" onClick={onClick}>
    <ProgramTopicPostHeader last={last} postType={post.type} type={type} />
    <ProgramTopicPostBody last={last} post={post} type={type} />
  </Flex>
);

export default ProgramTopicPost;
